import { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/shared/constants/route-name";
import { DefaultLayout } from "@/layouts";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/contact-groups",
    name: RouteName.CONTACT_GROUPS,
    component: () =>
      import(
        /* webpackChunkName: "contact-groups-page" */ "../views/contact-groups-page.vue"
      ),
    meta: {
      requiresAuth: true,
      layout: DefaultLayout
    }
  }
];

export default routes;
